module.exports = __webpack_public_path__ + "wordmark.46661d6d.svg";